<template>
    <div class="form" >
        <div class="form-mask" @click="close()"></div>
        <div class="form-container">
            <password-reset
                    v-if="reset_password"
                    @openSignIn="reset_password = false"
                    @close="close"
            ></password-reset>
            <div class="main-form" v-else>
                <div class="form-header">
                    <div class="switcher signin"
                         :class="{'active': active === 'signin'}"
                         @click="active = 'signin'"
                    >Вход</div>
                    <div class="switcher register"
                         :class="{'active': active === 'register'}"
                         @click="active = 'register'"
                    >Регистрация</div>
                </div>
                <div class="form-body">
                    <div class="signin" v-if="active === 'signin'">
                        <div class="signin-social">
                            <div class="signin-social__button google">
                                <span>
                                    <img :src="require('@/assets/img/Google.svg')" alt="Google">
                                </span>
                                <span class="text">Продолжить с Google</span>
                            </div>
                            <div class="signin-social__button telegram">
                                <img :src="require('@/assets/img/telegram-white.svg')" alt="telegram">
                                <span class="text">Продолжить с Telegramm</span>
                            </div>
                            <div class="signin-social__button facebook">
                                <img :src="require('@/assets/img/fb-white.svg')" alt="facebook">
                                <span class="text">Продолжить с Facebook</span>
                            </div>
                        </div>
                        <div class="signin-separator">
                            <div>Или</div>
                        </div>
                        <div class="signin-usual">
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="text" placeholder="Почта или телефон" v-model="signIn.contact" :class="{'validate': errors.length}">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="password" placeholder="Пароль" v-model="signIn.password" :class="{'validate': errors.length}">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>

<!--                            <ValidationProvider>-->
<!--                            </ValidationProvider>-->
                        </div>
                        <div class="signin-controls">
                            <div class="signin-button">Войти</div>
                            <div class="reset-password">
                                <span @click="reset_password = true">Сброс пароля</span>
                            </div>
                        </div>
                    </div>
                    <div class="register" v-else>
                        <div>
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="text" placeholder="Имя, фамилия" v-model="signUp.name">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="text" placeholder="Телефон или E-mail" v-model="signUp.contact">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="password" placeholder="Пароль" v-model="signUp.password">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="signin-usual__input">
                                <ValidationProvider rules="required" immediate v-slot="{ errors }" >
                                    <input type="password" placeholder="Повторите пароль" v-model="signUp.repeatPassword">
                                    <span class="input-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <button class="register-button" @click="registerUser()">Зарегистрироваться</button>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
    import PasswordReset from "./PasswordReset";
    export default {
        name: "SignInForm",
        components: {PasswordReset},
        data() {
            return {
                active: 'signin',
                reset_password: false,
                signIn: {
                    contact: '',
                    password: ''
                },
                signUp: {
                    name: '',
                    contact: '',
                    password: '',
                    repeatPassword: ''
                }
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            registerUser() {}
        }
    }
</script>

<style scoped lang="scss">
    .form {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        &-mask {
            height: 100%;
            width: 100%;
            background: rgba(63, 68, 80, .6);
            position: absolute;
            z-index: 100;

        }
        &-container {
            border-radius: 7px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            position: absolute;
            width: 360px;
            background-color: #fff;
            z-index: 101;
        }
        &-header {
            height: 48px;
            display: flex;
            .switcher {
                background-color: #F2F5F8;
                color: #686F83;
                font-size: 16px;
                padding: 16px 20px;
                text-align: center;
                width: 50%;
                &.signin {
                    border-top-left-radius: 7px;
                }
                &.register {
                    border-top-right-radius: 7px;
                }
                &.active {
                    background: linear-gradient(77.1deg, #6BBCBA 0%, #3BA5A1 100%);
                    color: #FCFCFC;
                }
            }
        }
        &-body {
            padding: 32px 24px;
            input {
                height: 48px;
                border: 1px solid #D8DDE4;
                border-radius: 5px;
                font-size: 14px;
                line-height: 21px;
                padding: 8px 16px;
                width: 100%;
                &::placeholder {
                    color: #878EA0;
                }
                &.validate {
                    border: 1px solid #EE5253;
                }
                /*&:not(:last-child) {*/
                /*    margin-bottom: 20px;*/
                /*}*/
            }
            .signin {
                &-usual {
                    &__input {
                        margin-bottom: 20px;
                    }
                }
                &-social {
                    &__button {
                        cursor: pointer;
                        height: 40px;
                        width: 100%;
                        box-sizing: border-box;
                        border-radius: 999px;
                        display: flex;
                        justify-content: center;
                        padding: 8px 0;
                        align-items: center;
                        &:not(:last-child) {
                            margin-bottom: 16px;
                        }
                        img {
                            margin-right: 8px;
                        }
                        &.google {
                            background-color: #FCFCFC;
                            border: 1px solid #D8DDE4;
                            .text {
                                color: #686F83;
                            }
                        }
                        &.telegram {
                            background-color: #039BE5;
                            .text {
                                color: #F2F5F8;
                            }
                        }
                        &.facebook {
                            background-color: #475993;
                            .text {
                                color: #FCFCFC;
                            }
                        }
                        .text {
                            font-size: 14px;
                            line-height: 21px;
                        }
                    }

                }
                &-separator {
                    display: flex;
                    align-items: center;
                    padding: 16px 0;
                    div {
                        color: #878EA0;
                        font-size: 14px;
                        line-height: 21px;
                        padding: 0 12px;
                    }
                    &:before {
                        background-color: #D8DDE4;
                        display: block;
                        content: '';
                        width: 50%;
                        height: 1px;
                    }
                    &:after {
                        background-color: #D8DDE4;
                        display: block;
                        content: '';
                        width: 50%;
                        height: 1px;
                    }
                }
                .reset-password {
                    display: flex;
                    justify-content: center;
                    color: #3FB0AB;
                    font-size: 14px;
                    line-height: 21px;
                    margin-top: 16px;
                    span {
                        &:after {
                            background-color: #3FB0AB;
                            display: block;
                            content: '';
                            height: 1px;
                            width: 100px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .register, .signin {
                &-button {
                    background: linear-gradient(64.54deg, #6BBCBA 0%, #3BA5A1 100%);
                    border: none;
                    border-radius: 5px;
                    font-size: 16px;
                    line-height: 25px;
                    color: #FCFCFC;
                    padding: 8px 24px;
                    text-align: center;
                    margin-top: 24px;
                    width: 100%;
                    cursor: pointer;
                }
            }
        }
    }
</style>
